var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcMoreV(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,6 C9.825,6 10.5,5.325 10.5,4.5 C10.5,3.675 9.825,3 9,3 C8.175,3 7.5,3.675 7.5,4.5 C7.5,5.325 8.175,6 9,6 Z M9,7.5 C8.175,7.5 7.5,8.175 7.5,9 C7.5,9.825 8.175,10.5 9,10.5 C9.825,10.5 10.5,9.825 10.5,9 C10.5,8.175 9.825,7.5 9,7.5 Z M9,12 C8.175,12 7.5,12.675 7.5,13.5 C7.5,14.325 8.175,15 9,15 C9.825,15 10.5,14.325 10.5,13.5 C10.5,12.675 9.825,12 9,12 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcMoreV);
export default __webpack_public_path__ + "static/media/18_ic_more_v.ee4fd747.svg";
export { ForwardRef as ReactComponent };